import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-f-small', 'IconLetterFSmall', [["path",{"d":"M10 12h3","key":"svg-0"}],["path",{"d":"M14 8h-4v8","key":"svg-1"}]]);